export default {
    points: {
        required: true,
        message: 'Point tidak boleh kosong!',
    },
}